import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { Layout, Modal } from 'antd';
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Loading from '../../../utils/Loading';

import { onMessageListener } from '../../../apis/firebaseAPI';

import { getQuestion } from '../../../redux/features/gamePresentationSlice';

import './PresentationConsole.css';
import { signOut } from '../../../redux/features/authSlice';
const { Header, Content, Sider } = Layout;

const PresentationConsole = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {id} = useParams();

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [isVisible, setIsVisible] = useState(!document.hidden);

  const authInfo = useSelector(state => state.auth);
  const gamePresentation = useSelector(state => state.gamePresentation);

  const [isQuitModal, setIsQuitModal] = useState(false);

  useEffect(() => {
    dispatch(getQuestion({roomId: id}));
  }, [])

  useEffect(() => {
    if (!authInfo.role.includes('player*' + id)) {
      navigate("/");
    }
  }, [authInfo.role, navigate, id]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };
    // Event listener for visibility change
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const subscribeToMessages = async () => {
    try {
      const payload = await onMessageListener();
      console.log('Message received. ', payload);
      // Handle the message
      if (payload.data.end === 'true') {
        console.log('end');
        setIsQuitModal(true);
      } else {
        dispatch(getQuestion({ roomId: id }));
      }
    } catch (err) {
      console.log('Failed to receive message', err);
    }
  };

  useEffect(() => {
    let isSubscribed = true;
    if(isVisible) {
      if(isSubscribed) {
        subscribeToMessages();
      }
    }
    return () => {
      console.log("unsubscribe");
      isSubscribed = false; // Unsubscribe when the component is unmounted
    };
  });

  // onMessageListener().then(payload => {
  //   console.log(payload);
  // }).catch(err => console.log('failed: ', err));

  const handleOpenUserMenu = (event) => {
    console.log("here");
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleGoHome = () => {
    dispatch(signOut({roomId: id, role: 'player'}));
    navigate("/");
  }

  return (
    <>
      {gamePresentation.loading && <Loading/>}
     <Layout className="captain-body">
     <Header
        className="captain-header"
      >
         <Box sx={{ flexGrow: 1 }}>
            <Tooltip title="Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, float: "right" }}>
                    <Icon sx={{color: 'white', fontSize: 32}}>account_circle</Icon>
                </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px"}}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem key="home" onClick={handleGoHome}>
                  <Typography textAlign="center">Home</Typography>
              </MenuItem>
            </Menu>
          </Box>
      </Header>
      <Layout>
        <Sider
          // width={200}
          className="captain-sider"
        >
            <h3 className='captain-game-info'>&nbsp;&nbsp;&nbsp;&nbsp;Round {gamePresentation.currentRound + 1}</h3>
            <h3 className='captain-game-info'>Question {gamePresentation.currentQuestion + 1}</h3>
        </Sider>
        <Layout
          style={{
            padding: '0 24px 24px',
          }}
        >
          <Content className="captain-content">
            <Typography variant="h5" className="question">
              {gamePresentation.question ? gamePresentation.question : "Question"}
            </Typography>
            <div className="question-image-div">
              <img src={gamePresentation.question_image} alt="Question img" className="question-image"/>
            </div>

            <Modal
              title="Game Over"
              open={isQuitModal}
              closeIcon={false}
              footer={[
                <Button key="submit" type="primary" onClick={handleGoHome}>
                  GO HOME
                </Button>
              ]}
            >
              Game is Over!
            </Modal>
          </Content>
        </Layout>
      </Layout>
    </Layout>
      
    </>
  );
};

export default PresentationConsole;